module.exports = __webpack_public_path__ + "static/images/cover_C8.5580086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C8.png
// module id = ygEa
// module chunks = 8